var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserFeedback = function SvgUserFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.021 17c1.082 0 1.979.91 1.979 2.01v12.296c0 1.1-.897 2.011-1.979 2.011H36.39v3.888c0 .3-.166.575-.43.71a.77.77 0 0 1-.817-.071L29.1 33.317H16.979c-1.082 0-1.979-.91-1.979-2.01V19.01c0-1.1.897-2.011 1.979-2.011zm-4.683 9.571H21.666a.789.789 0 0 0-.78.795c0 .439.349.795.78.795h11.672c.432 0 .781-.356.781-.795a.789.789 0 0 0-.78-.795zm-11.751-3.833a.791.791 0 0 0-.723.833.788.788 0 0 0 .802.755h7.763a.779.779 0 0 0 .692-.392.806.806 0 0 0 0-.804.779.779 0 0 0-.692-.392h-7.763a.768.768 0 0 0-.08 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-feedback.0bb4ec31.svg";
export { ForwardRef as ReactComponent };